<section class="register-user__max-distance-field">
  <header class="max-distance-field__header">
    <h3 class="max-distance-field__title ci-heading-h3-s-bold">
      {{ 'Distancia máxima' | translate }}
    </h3>

    <span class="ci-paragraph-p1-regular max-distance-field__helper-text">
      {{ 'Establece una distancia máxima de desplazamiento andando entre recursos' | translate }} 
      <strong> ({{ 'obligatorio' | translate }})</strong>
    </span>
  </header>

  
  <main class="register-user__slider-max-distance">
    <ci-slider
      class="slider-max-distance__wc"
      [min]="10"
      [max]="50"
      [step]="10"
      [value]="sliderValue"
      (change)="handleSliderMaxDistanceChange($event)"
    ></ci-slider>
    
    <ul class="slider-max-disctance__labels">
      @for (item of maxDistanceWalkingLabels; track item.value) {
        <li 
          class="slider-max-disctance__label ci-paragraph-p1-regular"
          [class.actived]="form().get('maxDistanceWalking')?.value === item.value"
          [attr.data-value]="item.value"
          (click)="handleMaxDistanceWalkingLabelClick(item.value)"
        >
          {{ item.label }}
        </li>
      }
    </ul>
  </main>
</section>